var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 79,
    viewBox: "0 0 64 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .237h63.579V36H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 42.6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M38.636 36L.85 14.61c-1.129-.635-1.134-1.684-.013-2.332L20.853.723c1.121-.648 2.956-.648 4.077 0l37.812 21.83c1.121.647 1.115 1.697-.013 2.332L42.74 36",
    fill: "#00A4BF",
    opacity: 0.2,
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.462 14.77c0-1.1-.779-2.45-1.732-3L43.08 2.736c-.954-.55-1.733-.1-1.733 1v39.07c0 1.102.78 2.45 1.732 3l15.651 9.037c.953.55 1.732.1 1.732-1V14.77z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.462 14.77c0-1.1-.779-2.45-1.732-3L43.08 2.736c-.496-.286-.945-.302-1.262-.096-.292.19-.47.569-.47 1.096v39.07c0 1.102.778 2.45 1.731 3l15.651 9.037c.496.286.944.302 1.261.096.292-.19.471-.567.471-1.096V14.77zM41.347 18.597c0-1.101-.78-2.45-1.732-3L23.965 6.56c-.954-.55-1.733-.1-1.733 1v24.07c0 1.102.78 2.45 1.732 3l15.651 9.037c.952.55 1.732.1 1.732-1V18.597z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 18.597c0-1.101-.78-2.45-1.732-3L23.965 6.56c-.497-.286-.945-.302-1.262-.096-.292.19-.47.568-.47 1.096v24.07c0 1.102.778 2.45 1.731 3l15.651 9.037c.952.55 1.732.1 1.732-1V18.597zM49.812 11.677l-5.358-3.094v6.188l5.358 3.093zM57.356 15.745l-5.359-3.094v6.188l5.36 3.093zM49.812 20.468l-5.358-3.094v6.187l5.358 3.094zM57.356 24.536l-5.359-3.094v6.188l5.36 3.093zM49.812 29.258l-5.358-3.094v6.188l5.358 3.093zM57.356 33.327l-5.359-3.094v6.188l5.36 3.093z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.697 15.376l-5.36-3.094v6.188l5.36 3.093zM38.24 19.445l-5.358-3.095v6.188l5.359 3.093zM46.672 47.88l7.544 4.355v-11.09l-7.544-4.356zM27.517 36.684l7.545 4.355V28.21l-7.544-4.355z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 27.208c0-1.1-.78-2.45-1.732-3l-15.65-9.036c-.954-.55-1.733-.1-1.733 1v39.071c0 1.1.78 2.45 1.732 3l15.651 9.036c.952.55 1.732.1 1.732-1V27.21z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 27.208c0-1.1-.78-2.45-1.732-3l-15.65-9.036c-.497-.286-.945-.302-1.262-.096-.292.19-.47.568-.47 1.096v39.071c0 1.1.778 2.45 1.731 3l15.651 9.036c.496.286.944.301 1.261.096.292-.19.471-.568.471-1.096V27.21zM22.232 31.033c0-1.1-.78-2.449-1.732-3L4.85 18.998c-.954-.55-1.733-.1-1.733 1v24.071c0 1.1.78 2.45 1.732 3L20.5 56.105c.952.55 1.732.1 1.732-1V31.033z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.232 31.033c0-1.1-.78-2.449-1.732-3L4.85 18.998c-.497-.286-.945-.302-1.262-.096-.292.19-.47.568-.47 1.095V44.07c0 1.1.778 2.45 1.731 3L20.5 56.105c.952.55 1.732.1 1.732-1V31.033zM30.697 24.113l-5.36-3.093v6.188l5.36 3.093zM38.24 28.183l-5.358-3.094v6.188l5.359 3.093zM30.697 32.904l-5.36-3.094V36l5.36 3.093zM38.24 36.974l-5.358-3.094v6.188l5.359 3.093zM30.697 41.696l-5.36-3.094v6.188l5.36 3.093zM38.24 45.764l-5.358-3.094v6.188l5.359 3.093z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.582 27.814l-5.36-3.094v6.187L11.583 34zM19.126 31.882l-5.36-3.094v6.188l5.36 3.093zM27.556 60.318l7.544 4.355V53.582l-7.544-4.356zM8.402 49.121l7.545 4.355V40.648l-7.544-4.355zM58.73 11.77L43.08 2.736c-.496-.286-.945-.302-1.262-.096L22.703 15.077c.317-.206.765-.191 1.261.095l15.651 9.037c.388.223.747.58 1.037.999.421.609.695 1.348.695 2V66.28c0 .527-.179.905-.47 1.095L59.99 54.938c.292-.19.471-.568.471-1.096V14.77c0-1.1-.779-2.45-1.732-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.703 6.465L3.588 18.903c.317-.207.765-.192 1.26.094L20.5 28.033c.953.55 1.732 1.901 1.732 3v-14.86c0-.54.189-.92.492-1.106-.006.004-.015.004-.021.01l7.527-4.898-6.266-3.618c-.495-.286-.944-.302-1.261-.096M51.998 24.103l5.358-3.28v6.187l-5.358 3.28zM44.453 28.435l5.358-3.28v6.187l-5.358 3.28zM51.998 32.894l5.358-3.281V35.8l-5.358 3.28zM44.453 37.226l5.358-3.28v6.186l-5.358 3.28zM51.998 41.685l5.358-3.281v6.187l-5.358 3.28zM44.453 46.017l5.358-3.281v6.187l-5.358 3.28z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73 11.77L43.08 2.736c-.496-.286-.945-.302-1.262-.096L22.703 15.077c.317-.206.765-.191 1.261.095l15.651 9.037c.388.223.747.58 1.037.999l19.311-12.124c-.315-.551-.75-1.035-1.233-1.313z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73 11.77L43.08 2.736c-.496-.286-.945-.302-1.262-.096L22.703 15.077c.317-.206.765-.191 1.261.095l15.651 9.037c.388.223.747.58 1.037.999.421.609.695 1.348.695 2V66.28c0 .527-.179.905-.47 1.095L59.99 54.938c.292-.19.471-.568.471-1.096V14.77c0-1.1-.779-2.45-1.732-3z",
    stroke: "#33475C",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.462 14.77c0-1.1-.779-2.45-1.732-3L43.08 2.736c-.954-.55-1.733-.1-1.733 1v39.07c0 1.102.78 2.45 1.732 3l15.651 9.037c.953.55 1.732.1 1.732-1V14.77z",
    fill: "#7BDED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.462 14.77c0-1.1-.779-2.45-1.732-3L43.08 2.736c-.496-.286-.945-.302-1.262-.096-.292.19-.47.569-.47 1.096v39.07c0 1.102.778 2.45 1.731 3l15.651 9.037c.496.286.944.302 1.261.096.292-.19.471-.567.471-1.096V14.77z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 18.597c0-1.101-.78-2.45-1.732-3L23.965 6.56c-.954-.55-1.733-.1-1.733 1v24.07c0 1.102.78 2.45 1.732 3l15.651 9.037c.952.55 1.732.1 1.732-1V18.597z",
    fill: "#7BDED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 18.597c0-1.101-.78-2.45-1.732-3L23.965 6.56c-.497-.286-.945-.302-1.262-.096-.292.19-.47.568-.47 1.096v24.07c0 1.102.778 2.45 1.731 3l15.651 9.037c.952.55 1.732.1 1.732-1V18.597z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M49.812 11.677l-5.358-3.094v6.188l5.358 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M49.812 11.677l-5.358-3.094v6.188l5.358 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M57.356 15.745l-5.359-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M57.356 15.745l-5.359-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M49.812 20.468l-5.358-3.094v6.187l5.358 3.094z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M49.812 20.468l-5.358-3.094v6.187l5.358 3.094z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M57.356 24.536l-5.359-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M57.356 24.536l-5.359-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M49.812 29.258l-5.358-3.094v6.188l5.358 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M49.812 29.258l-5.358-3.094v6.188l5.358 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M57.356 33.327l-5.359-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M57.356 33.327l-5.359-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M30.697 15.376l-5.36-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.697 15.376l-5.36-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M38.24 19.445l-5.358-3.095v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.24 19.445l-5.358-3.095v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD6E3",
    d: "M46.672 47.88l7.544 4.355v-11.09l-7.544-4.356z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M46.672 47.88l7.544 4.355v-11.09l-7.544-4.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD6E3",
    d: "M27.517 36.684l7.545 4.355V28.21l-7.544-4.355z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.517 36.684l7.545 4.355V28.21l-7.544-4.355z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 27.208c0-1.1-.78-2.45-1.732-3l-15.65-9.036c-.954-.55-1.733-.1-1.733 1v39.071c0 1.1.78 2.45 1.732 3l15.651 9.036c.952.55 1.732.1 1.732-1V27.21z",
    fill: "#40CEBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 27.208c0-1.1-.78-2.45-1.732-3l-15.65-9.036c-.954-.55-1.733-.1-1.733 1v39.071c0 1.1.78 2.45 1.732 3l15.651 9.036c.952.55 1.732.1 1.732-1V27.21z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.347 27.208c0-1.1-.78-2.45-1.732-3l-15.65-9.036c-.497-.286-.945-.302-1.262-.096-.292.19-.47.568-.47 1.096v39.071c0 1.1.778 2.45 1.731 3l15.651 9.036c.496.286.944.301 1.261.096.292-.19.471-.568.471-1.096V27.21z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.232 31.033c0-1.1-.78-2.449-1.732-3L4.85 18.998c-.954-.55-1.733-.1-1.733 1v24.071c0 1.1.78 2.45 1.732 3L20.5 56.105c.952.55 1.732.1 1.732-1V31.033z",
    fill: "#00BEA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.232 31.033c0-1.1-.78-2.449-1.732-3L4.85 18.998c-.954-.55-1.733-.1-1.733 1v24.071c0 1.1.78 2.45 1.732 3L20.5 56.105c.952.55 1.732.1 1.732-1V31.033z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.232 31.033c0-1.1-.78-2.449-1.732-3L4.85 18.998c-.497-.286-.945-.302-1.262-.096-.292.19-.47.568-.47 1.095V44.07c0 1.1.778 2.45 1.731 3L20.5 56.105c.952.55 1.732.1 1.732-1V31.033z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M30.697 24.113l-5.36-3.093v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.697 24.113l-5.36-3.093v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M38.24 28.183l-5.358-3.094v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.24 28.183l-5.358-3.094v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M30.697 32.904l-5.36-3.094V36l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.697 32.904l-5.36-3.094V36l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M38.24 36.974l-5.358-3.094v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.24 36.974l-5.358-3.094v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M30.697 41.696l-5.36-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M30.697 41.696l-5.36-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M38.24 45.764l-5.358-3.094v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.24 45.764l-5.358-3.094v6.188l5.359 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M11.582 27.814l-5.36-3.094v6.187L11.583 34z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.582 27.814l-5.36-3.094v6.187L11.583 34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5F5F8",
    d: "M19.126 31.882l-5.36-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.126 31.882l-5.36-3.094v6.188l5.36 3.093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD6E3",
    d: "M27.556 60.318l7.544 4.355V53.582l-7.544-4.356z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M27.556 60.318l7.544 4.355V53.582l-7.544-4.356z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CBD6E3",
    d: "M8.402 49.121l7.545 4.355V40.648l-7.544-4.355z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.402 49.121l7.545 4.355V40.648l-7.544-4.355z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73 11.77L43.08 2.736c-.496-.286-.945-.302-1.262-.096L22.703 15.077c.317-.206.765-.191 1.261.095l15.651 9.037c.388.223.747.58 1.037.999.421.609.695 1.348.695 2V66.28c0 .527-.179.905-.47 1.095L59.99 54.938c.292-.19.471-.568.471-1.096V14.77c0-1.1-.779-2.45-1.732-3",
    fill: "#7BDED2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73 11.77L43.08 2.736c-.496-.286-.945-.302-1.262-.096L22.703 15.077c.317-.206.765-.191 1.261.095l15.651 9.037c.388.223.747.58 1.037.999.421.609.695 1.348.695 2V66.28c0 .527-.179.905-.47 1.095L59.99 54.938c.292-.19.471-.568.471-1.096V14.77c0-1.1-.779-2.45-1.732-3z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.703 6.465L3.588 18.903c.317-.207.765-.192 1.26.094L20.5 28.033c.953.55 1.732 1.901 1.732 3v-14.86c0-.54.189-.92.492-1.106-.006.004-.015.004-.021.01l7.527-4.898-6.266-3.618c-.495-.286-.944-.302-1.261-.096",
    fill: "#E4F8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.703 6.465L3.588 18.903c.317-.207.765-.192 1.26.094L20.5 28.033c.953.55 1.732 1.901 1.732 3v-14.86c0-.54.189-.92.492-1.106-.006.004-.015.004-.021.01l7.527-4.898-6.266-3.618c-.495-.286-.944-.302-1.261-.096",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4F8F6",
    d: "M51.998 24.103l5.358-3.28v6.187l-5.358 3.28zM44.453 28.435l5.358-3.28v6.187l-5.358 3.28zM51.998 32.894l5.358-3.281V35.8l-5.358 3.28zM44.453 37.226l5.358-3.28v6.186l-5.358 3.28zM51.998 41.685l5.358-3.281v6.187l-5.358 3.28zM44.453 46.017l5.358-3.281v6.187l-5.358 3.28zM58.73 11.77L43.08 2.736c-.496-.286-.945-.302-1.262-.096L22.703 15.077c.317-.206.765-.191 1.261.095l15.651 9.037c.388.223.747.58 1.037.999l19.311-12.124c-.315-.551-.75-1.035-1.233-1.313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.73 11.77L43.08 2.736c-.496-.286-.945-.302-1.262-.096L22.703 15.077c.317-.206.765-.191 1.261.095l15.651 9.037c.388.223.747.58 1.037.999.421.609.695 1.348.695 2V66.28c0 .527-.179.905-.47 1.095L59.99 54.938c.292-.19.471-.568.471-1.096V14.77c0-1.1-.779-2.45-1.732-3z",
    stroke: "#33475C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSss);
export default __webpack_public_path__ + "static/media/sss.5fd898ac0e5ab4634fda0343eb8fb91e.svg";
export { ForwardRef as ReactComponent };